import React from 'react';

const SampleLabelSticker = ({ sample, product }) => {
  const isReady = sample && product;

  // Menghapus logika QR Data sesuai permintaan user

  // Ekstrak kode dan nama varian dari format "KODE - VARIAN" atau "VARIAN - KODE"
  let variantName = isReady ? (product.nama_produk || '') : '';
  let printCode = '';
  
  if (isReady && product.racikan) {
    const bibit = product.racikan.find(r => r.kategori_bahan === 'Bibit' && !r.dari_client);
    if (bibit && bibit.nama_bahan) {
      const parts = bibit.nama_bahan.split(' - ');
      if (parts.length > 1) {
        // Cek bagian mana yang lebih mirip kode (mengandung angka dan lebih pendek, atau tidak ada spasi)
        const p0 = parts[0].trim();
        const p1 = parts.slice(1).join('-').trim();
        
        const isCode = (str) => /\d/.test(str) && str.length <= 15;
        
        if (isCode(p0) && !isCode(p1)) {
          printCode = p0;
        } else if (isCode(p1) && !isCode(p0)) {
          printCode = p1;
        } else if (p0.length < p1.length) {
          printCode = p0;
        } else {
          printCode = p1;
        }
      } else {
        // Fallback: cari kata mana saja yang mengandung angka (dianggap sebagai kode)
        const words = bibit.nama_bahan.split(' ');
        const codeWord = words.find(w => /\d/.test(w) && w.length <= 15);
        if (codeWord) {
          printCode = codeWord;
        }
      }
    }
  }

  if (isReady && !printCode && variantName.includes('-')) {
    const parts = variantName.split('-');
    const p1 = parts[0].trim();
    const p2 = parts.slice(1).join('-').trim();
    
    // Deteksi kode (biasanya lebih pendek atau mengandung angka)
    if (p1.length <= 10 && /\d/.test(p1)) {
      printCode = p1;
      variantName = p2;
    } else if (p2.length <= 12 && /\d/.test(p2)) {
      printCode = p2;
      variantName = p1;
    } else if (p1.length < p2.length) {
      printCode = p1;
      variantName = p2;
    } else {
      printCode = p2;
      variantName = p1;
    }
  }

  // Prevent duplicate text if they are exactly the same
  if (printCode && variantName) {
    const vTrim = variantName.trim();
    const pTrim = printCode.trim();
    if (pTrim.toLowerCase() === vTrim.toLowerCase()) {
      printCode = '';
    } else {
      // Remove printCode from the end of variantName if the user included it
      const codeRegex = new RegExp(`\\s+${pTrim}$`, 'i');
      if (codeRegex.test(vTrim)) {
        variantName = vTrim.replace(codeRegex, '').trim();
      }
    }
  }

  // Format tanggal: 02 Juli 2026
  let tanggal = '';
  if (isReady) {
    const dateObj = new Date(sample.created_date || Date.now());
    const months = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];
    tanggal = `${String(dateObj.getDate()).padStart(2, '0')} ${months[dateObj.getMonth()]} ${dateObj.getFullYear()}`;
  }

  // Ganti warna menjadi hitam sesuai permintaan user
  const goldenColor = '#000000'; // Disesuaikan agar lebih mirip dengan warna emas gelap di mockup

  if (!isReady) return null;

  // Fungsi untuk mengubah teks menjadi Title Case
  const toTitleCase = (str) => {
    if (!str) return '';
    return str.toLowerCase().replace(/\b\w/g, s => s.toUpperCase());
  };

  const fullVariantText = `${toTitleCase(variantName)} ${product?.label ? `(${product.label})` : ''}`.trim();
  const hasCode = Boolean(printCode);
  const textLen = fullVariantText.length;

  let itemFontSize = '5.5pt';
  let itemLineHeight = 1.1;
  let itemLineClamp = hasCode ? 2 : 3;

  if (hasCode) {
    if (textLen > 32) {
      itemFontSize = '4.2pt';
      itemLineHeight = 1.05;
    } else if (textLen > 20) {
      itemFontSize = '4.8pt';
      itemLineHeight = 1.08;
    } else {
      itemFontSize = '5.5pt';
    }
  } else {
    if (textLen > 40) {
      itemFontSize = '4.4pt';
      itemLineHeight = 1.05;
      itemLineClamp = 3;
    } else if (textLen > 24) {
      itemFontSize = '5.0pt';
      itemLineHeight = 1.08;
      itemLineClamp = 3;
    } else {
      itemFontSize = '5.5pt';
      itemLineClamp = 2;
    }
  }

  return (
    <div className="bg-white border border-black box-border relative overflow-hidden shrink-0" style={{ width: '40mm', height: '20mm', fontFamily: '"Poppins", sans-serif' }}>

      {/* Content Container */}
      <div className="relative z-10 w-full h-full pt-[1mm] pb-[1mm] px-[1.5mm] flex flex-col">
        
        {/* Header Section */}
        <div className="flex items-center gap-[1.5mm] mb-[0.5mm] w-full shrink-0">
          {/* Logo */}
          <div className="flex items-center justify-center shrink-0 w-[4.5mm] h-[4.5mm]">
              <img src="/logo hitam sde.png" alt="Logo" className="w-full h-full object-contain object-left" />
          </div>
          {/* Company & Address */}
          <div className="flex flex-col justify-center flex-1 pb-[0.2mm]">
            <span style={{ color: goldenColor, fontSize: '4.76pt', fontWeight: 600, fontStyle: 'italic', lineHeight: 1.1 }}>
              PT. Satala Dermatech Essential
            </span>
            <span style={{ color: goldenColor, fontSize: '2.5pt', fontStyle: 'italic', fontWeight: 400, lineHeight: 1.1, marginTop: '0.2mm' }}>
              Jl.Aster Kav, Paspampres Kota Batu, Kab. Bogor, Jawa Barat
            </span>
          </div>
        </div>

        {/* Divider Line */}
        <div className="shrink-0" style={{ height: '0.4pt', backgroundColor: goldenColor, width: '100%', marginBottom: '0.8mm' }} />

        {/* Body Section */}
        <div className="flex-1 relative w-full flex flex-col overflow-hidden">
          
          <div className="flex-1 flex flex-col items-center justify-center w-full px-[1.5mm]">
            <span style={{ color: goldenColor, fontSize: '4.5pt', fontWeight: 600, fontStyle: 'italic', lineHeight: 1, textAlign: 'center' }}>
              {toTitleCase(sample.nama_brand)}
            </span>
            <span 
              style={{ 
                color: goldenColor, 
                fontSize: itemFontSize, 
                fontWeight: 600, 
                fontStyle: 'italic', 
                lineHeight: itemLineHeight, 
                margin: '0.3mm 0', 
                textAlign: 'center', 
                wordBreak: 'break-word', 
                display: '-webkit-box', 
                WebkitLineClamp: itemLineClamp, 
                WebkitBoxOrient: 'vertical', 
                overflow: 'hidden' 
              }}
            >
              {fullVariantText}
            </span>
            
            {/* Tampilkan kode yang sudah diekstrak di bawah nama varian */}
            {printCode && (
              <span style={{ color: goldenColor, fontSize: '4pt', fontWeight: 600, fontStyle: 'italic', lineHeight: 1, textAlign: 'center', marginTop: '0.3mm' }}>
                {printCode}
              </span>
            )}
          </div>

          <div className="w-full flex items-end mt-auto pb-[0.2mm] px-[1.5mm] shrink-0">
            <div className="flex-1" />
            <span className="flex-none text-center" style={{ color: goldenColor, fontSize: '4.76pt', fontWeight: 600, fontStyle: 'italic', lineHeight: 1 }}>
              {tanggal}
            </span>
            <div className="flex-1 flex justify-end">
              <span style={{ color: goldenColor, fontSize: '4.5pt', fontStyle: 'italic', fontWeight: 700, lineHeight: 1 }}>
                {isReady ? `${String(sample.id).slice(-4).toUpperCase()}-${String(product._id || product.id || '0000').slice(-4).toUpperCase()}` : ''}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SampleLabelSticker;
